jQuery(document).ready(function($){


    // localStorage.setItem('b3g2_current_page',$('#black-friday-popup').attr('data-current-handle'));
    // localStorage.removeItem('b3g2_load');

    // setTimeout(function(){
    //     if (!localStorage.getItem('b3g2_load')){
    //         showOffer();
    //     }
    // },15000);
     

    $(document).on('click','.decline-text',function(){
        $.magnificPopup.close();
    });

    $(window).on('load',function(){
        $('body').addClass('loaded',function(){
          
        });

    });

    var selectedItems = [];
    var formBtn = $('.btn-quiz-form-action');

    var step = 1;

    var totalSelected = selectedItems.length;
    var totalItems = 3;
    var subTotal = 0;
    var freePriceAmount = 0;

    var step2DefaultImg = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/BF_Step_2_Default_1.png?v=1762924794';
    var step3DefaultImg = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/BF_Step_3_Default_1.png?v=1762924793';


    
    

    var totalItems = 0;

    $(document).on('click','.fon-product-variant .product-image, .fon-product-variant .product-title',function(){
        
        var outerParent = $(this).parents('.fon-product-variant');
        var parent = outerParent.find('.quiz-quantity-selector');
        var qty = parseInt(parent.attr('data-quantity'));
        var qtyValue = parent.find('.quantity-value');
        
        if (qty == 0){
            parent.find('.btn-quiz-qty[data-action="select"]').trigger('click');
        }
    });

    
    $(document).on('click','.btn-quiz-qty[data-action="select"]',function(){

        var parent = $(this).parents('.quiz-quantity-selector');
        var qty = parseInt(parent.attr('data-quantity'));
        var qtyValue = parent.find('.quantity-value');

        if (totalItems <= 2){

            qty++;

            parent.attr('data-quantity',qty).removeClass('disabled').addClass('active');
            qtyValue.html(qty);

        }
        countTotalItems();

    });

    $(document).on('click','.btn-quiz-qty[data-action="trash"]',function(){

        var parent = $(this).parents('.quiz-quantity-selector');
        var qty = parseInt(parent.attr('data-quantity'));
        var qtyValue = parent.find('.quantity-value');
        
        qty = 0;
        parent.attr('data-quantity',qty).removeClass('active');
        qtyValue.html(qty);

       

        countTotalItems();

    });

    $(document).on('click','.btn-quiz-qty[data-action="minus"]',function(){

        var parent = $(this).parents('.quiz-quantity-selector');
        var qty = parseInt(parent.attr('data-quantity'));
        var qtyValue = parent.find('.quantity-value');
        
        qty--;
        parent.attr('data-quantity',qty);
        qtyValue.html(qty);

        countTotalItems();

    });

    $(document).on('click','.btn-quiz-qty[data-action="plus"]',function(){

        var parent = $(this).parents('.quiz-quantity-selector');
        var qty = parseInt(parent.attr('data-quantity'));
        var qtyValue = parent.find('.quantity-value');
        
        if (totalItems <= 2){

            
            qty++;

            parent.attr('data-quantity',qty);
            qtyValue.html(qty);
            countTotalItems();

        }

    });

    const swiper = new Swiper(".swiper-welcomekit-slider", {
        slidesPerView: 1,       // Shows one slide at a time
        spaceBetween: 10,       // Space between slides
        loop: true,             // Infinite loop
        speed: 1000,            // Transition speed (ms)
        pagination: {
            el: ".swiper-pagination",  // Selector for pagination container
            clickable: true,           // Allows clicking on pagination bullets
        },
    });




    function showOffer(){

        localStorage.setItem('b3g2_load','1');

        $.magnificPopup.open({
            items: {
                src: '#black-friday-popup' // Target the element by its ID
            },
            fixedContentPos: true, // Locks background scroll
            closeMarkup: `
                <button title="%title%" type="button" class="mfp-close mfp-close-special">
                    <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
                        <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
                    </svg>
                </button>
            `
        });
    }
    function countTotalItems(){

        totalItems = 0;

        selectedItems = [];
        $('.quiz-quantity-selector.active').each(function () {

            var outerParent = $(this).parents('.quiz-variant-item');
            var variantID = outerParent.attr('data-variant-id');

            var qtyValue = parseInt($(this).find('.quantity-value').html());
            totalItems += qtyValue;

            for (i = 0; i < qtyValue; i++){
                selectedItems.push(variantID);
            }

        });

        console.log('xx selectedItems',selectedItems);
        generateItems();


        if (totalItems == 1){

            // if (!localStorage.getItem('b3g2_load')){
            //     showOffer();
            // }
        }

        if (totalItems == 3){
            $('body').addClass('selected-ok');
        }else{
            $('body').removeClass('selected-ok');
        }


        $('.bfcm-text-step').show().html('<h4>1. Select Your First Product</h4>');

        switch (totalItems){
            case 1:

            $('.section-quiz-buy-form h2.h2').html('Start Building My Bundle');

                $('.bfcm-text-step').html('<h4>2. Select Your Second Product</h4>');

                formBtn.html('Select Your Second Product').prop('disabled',true);
                $('.step-progess').css('width','15%');
            break;
            case 2:

            $('.section-quiz-buy-form h2.h2').html('Start Building My Bundle');

                $('.bfcm-text-step').html('<h4>3. Select Your Third Product</h4>');

                formBtn.html('Select Your Third Product').prop('disabled',true);
                $('.step-progess').css('width','56%');
            break;
            case 3:

                $('.bfcm-text-step').hide();

                formBtn.html('Checkout Now (Saving <span class="with-currency-code saving-amount"></span>)</span>').prop('disabled',false);
                $('.step-progess').css('width','100%');

                generateItems();

                $('.section-quiz-buy-form h2.h2').html('Congratulations!<strong class="d-block">Your third’s on us.</strong>');

            break;

        }
    }
    // $(document).on('click','.btn-quiz-qty',function(){

    //     var parent = $(this).parents('.quiz-variant-item');
    //     var variantID = parent.data('variant-id');
    //     var variantImageSRC = parent.data('selected-image');
    //     var variantImageMobileSRC = parent.data('selected-image-mobile');

    //     $('.fon-form-media-video').addClass('d-none');
    //     $('.fon-form-media-image').removeClass('d-none');

    //     // var variantImageSRC = parent.find('img').attr('src');
    //     // var variantImageMobileSRC = parent.find('img').attr('data-mobile');
        
    //     $('.fon-form-media-x img').attr('src',variantImageSRC);
    //     $('.fon-form-media-y img').attr('src',variantImageMobileSRC);



    //     switch (step){
    //         case 1:
                
    //             $('.btn-quiz-qty').removeClass('active').html('Select');
    //             $(this).addClass('active').html('Selected');
    //             formBtn.prop('disabled',false);

    //             selectedItems[0] = variantID;
    //             $('#offer .fon-bf-sub-total-wrapper h3').html('Your Items (1/3)');
                
    //             $('.btn-quiz-qty').prop('disabled',true);
    //             setTimeout(() => {
    //                 // formBtn.trigger('click');
    //                 $('.btn-quiz-form-action:not(.edit-mode)').trigger('click');

    //                 // Move next panel
    //                 if ($('.btn-quiz-form-action').hasClass('edit-mode')){
    //                     $('.selection-steps-buttons .step[data-step="2"]').trigger('click');   
    //                 }

    //                 $('.btn-quiz-qty').prop('disabled',false);
                    
    //             }, 1000);
                

    //         break;

    //         case 2:
                
    //             $('.btn-quiz-qty').removeClass('active').html('Select');
    //             $(this).addClass('active').html('Selected');
    //             formBtn.prop('disabled',false);

    //             selectedItems[1] = variantID;
    //             $('#offer .fon-bf-sub-total-wrapper h3').html('Your Items (2/3)');

    //             $('.btn-quiz-qty').prop('disabled',true);
    //             setTimeout(() => {

    //                 $('.btn-quiz-qty').prop('disabled',false);
    //                 // formBtn.trigger('click');
    //                 $('.btn-quiz-form-action:not(.edit-mode)').trigger('click');

    //                 // Move next panel
    //                 if ($('.btn-quiz-form-action').hasClass('edit-mode')){
    //                     $('.selection-steps-buttons .step[data-step="3"]').trigger('click');   
    //                 }

    //             }, 1000);

    //         break;
    //         case 3:
                
    //             $('.btn-quiz-qty').removeClass('active').html('Select');
    //             $(this).addClass('active').html('Selected');
    //             formBtn.prop('disabled',false).addClass('last-step');

    //             selectedItems[2] = variantID;

    //             $('#offer .fon-bf-sub-total-wrapper h3').html('Your Items (3/3)');

    //             setTimeout(() => {

    //                 $('.btn-quiz-qty').prop('disabled',false);
    //                 formBtn.trigger('click');

    //             }, 1000);

    //         break;

    //     }

    //     generateItems();


    // });

     $(document).on('click','.btn-quiz-form-action.edit-mode',function(){

        $('#offer-cart').fadeIn(function(){

            $('#offer').hide();

            $('html, body').animate({
            scrollTop: $('#offer-cart').offset().top
            }, 1000); // 600 = duration in ms

        });

    });
    // $(document).on('click','.btn-quiz-form-action:not(.edit-mode)',function(){

    //     var btn = $('.btn-quiz-qty');
    //     var parent = btn.parents('.quiz-variant-item');
    //     var variantID = parent.data('variant-id');
        
    //     console.log('selectedItems',selectedItems);
    //     formBtn.prop('disabled',true);
        
        
    //     switch (step){
    //         case 1:


                

    //             formBtn.html('Select Your Second Product').prop('disabled',true);

    //             $('[data-step]').removeClass('active');
    //             $('[data-step="2"]').addClass('active');

    //             $('.btn-quiz-qty').removeClass('active').html('Select');
                
    //             $('.step-progess').css('width','49%');
    //             $('.bfcm-text-step h4').html('2. Select Your Second Product');

    //             step++;

    //              $('html, body').animate({
    //                 scrollTop: $('section.section-quiz.section-quiz-buy-form h2.h2').offset().top
    //             }, 600); // 600 = duration in ms


               

    //             // Pre-select Step 2
    //             var stepIndex = 1; 
    //             if (selectedItems[stepIndex]){
    //                 $('.fon-bf-selected-products .bf-item').removeClass('active');
    //                 $('.quiz-variant-item[data-variant-id="'+selectedItems[stepIndex]+'"]').find('button').addClass('active').html('Selected');
    //                 // The container with the inner scroll
    //                 var $container = $('.fon-bf-products-selector .inner');

    //                 // The target element
    //                 var $target = $('.quiz-variant-item[data-variant-id="'+selectedItems[stepIndex]+'"]');

    //                 // Scroll so the target is visible
    //                 $container.animate({
    //                     scrollTop: $container.scrollTop() + $target.position().top
    //                 }, 500); // 500ms for smooth scrolling

    //                 formBtn.prop('disabled',false);
    //             }

    //         break;
    //         case 2:

             
    //             formBtn.html('Select Your Free Product and Checkout!').prop('disabled',true);

    //             $('[data-step]').removeClass('active');
    //             $('[data-step="3"]').addClass('active');

    //             $('.btn-quiz-qty').removeClass('active').html('Select');

    //             $('.step-progess').css('width','82%');
    //             $('.bfcm-text-step h4').html('3. Select Your Third Product');

    //             step++;

    //             $('html, body').animate({
    //                 scrollTop: $('section.section-quiz.section-quiz-buy-form h2.h2').offset().top
    //             }, 600); // 600 = duration in ms
                

    //             // Pre-select Step 3
    //             var stepIndex = 2; 
    //             if (selectedItems[stepIndex]){
    //                 $('.fon-bf-selected-products .bf-item').removeClass('active');
    //                 $('.quiz-variant-item[data-variant-id="'+selectedItems[stepIndex]+'"]').find('button').addClass('active').html('Selected');
    //                 // The container with the inner scroll
    //                 var $container = $('.fon-bf-products-selector .inner');

    //                 // The target element
    //                 var $target = $('.quiz-variant-item[data-variant-id="'+selectedItems[stepIndex]+'"]');

    //                 // Scroll so the target is visible
    //                 $container.animate({
    //                     scrollTop: $container.scrollTop() + $target.position().top
    //                 }, 500); // 500ms for smooth scrolling

    //                 formBtn.prop('disabled',false);
    //             }

    //         break;
    //         case 3:

    //             $('.step-progess').css('width','100%');

    //             formBtn.prop('disabled');
                
                
    //             $('#offer-cart').fadeIn(function(){

    //                 $('#offer').hide();

    //                 $('html, body').animate({
    //                 scrollTop: $('#offer-cart').offset().top
    //                 }, 1000); // 600 = duration in ms

                    
                    
                        
    //             });
                



                
                
    //         break;

    //     }

        

        

    // });

    function generateItems(){

        $('.bf-item').removeClass('active');
        subTotal = 0;


        var totalAmount = 0;
        var totalSaving = 0;

        // $('.fon-bf-sub-total-wrapper .fon-bf-selected-products').html('');
        
        $.each(selectedItems,function(index,value){

            index++;

            var item = '';
            var variant = $('.quiz-variant-item[data-variant-id="'+value+'"]');
            var variantID = variant.data('variant-id');
            var variantPrice = variant.data('variant-price');
            // var variantTitle = variant.find('.variant-actual-title').html();
            var variantTitle = variant.find('.variant-title').html();
            var variantPackaging = variant.find('.packaging').html();
            var variantImageSRC = variant.find('img').attr('src');

            // Step 1 and 2
            subTotal+=parseFloat(variantPrice);
            totalAmount+=parseFloat(variantPrice);

            textLabel = 'Your First Selected Product';
            if (index == 2){
                textLabel = 'Your Second Selected Product';
            }
            if (index == 3){
                textLabel = 'Your Third Selected Product';
            }
            
            if (!$('.bf-item[data-item="'+index+'"]').length){
                
                item+=`
                    <div class="bf-item ${ (index == 3 ) ? `lowest-pricex` : `` }" data-item="${index}">
                        <div class="image">
                            <img src="${variantImageSRC}"/>
                        </div>
                        <div class="title">
                            <span class="label-step">${textLabel}</span>
                            <span class="d-block"><span class="d-block d-md-inline">${variantTitle}</span></span>
                        </div>
                        <div class="price">
                            <span class="with-currency-code">${variantPrice}</span>
                        </div>
                    </div>
                `
                $('.fon-bf-sub-total-wrapper .fon-bf-selected-products').append(item);
            }else{
                $('.bf-item[data-item="'+index+'"]').find('.label-step').html(`${textLabel}`);
                $('.bf-item[data-item="'+index+'"]').find('.title .d-block').html(`${variantTitle}`);
                $('.bf-item[data-item="'+index+'"]').find('.price span').html(`${variantPrice}`);
                $('.bf-item[data-item="'+index+'"]').find('.image img').attr('src',variantImageSRC);
            }
            

            if (index == step){
                // $('.bf-item[data-item="'+index+'"]').addClass('active');
            }

        });

        var newtotalItems = totalItems;
        
        

        $('.fon-bf-sub-total .with-currency-code').html(subTotal);
        // $('.fon-bf-sub-total-wrapper').fadeIn();
        $('#offer-cart .total-items').html('(' + newtotalItems +  ' ITEMS)');
        

        totalSaving = 0;
        if (selectedItems.length === 3){

                    // CART
            var lowestClass = 'lowest-price';
            var $priceSpans = $('#offer .bf-item:not(.bf-item-add-on) .price span');

            // Extract numeric prices
            var prices = $priceSpans.map(function() {
                return parseFloat($(this).text().replace(/[^0-9.]/g, ''));
            }).get();

            // Find the minimum price
            var minPrice = Math.min.apply(null, prices);

            // Find all elements with the minimum price
            var $lowest = $priceSpans.filter(function() {
                return parseFloat($(this).text().replace(/[^0-9.]/g, '')) === minPrice;
            });

            // Remove previous class
            $priceSpans.parents('.bf-item').removeClass(lowestClass);

            // Add class to the last occurrence only
            $lowest.last().parents('.bf-item').addClass(lowestClass);

            freePriceAmount = minPrice;
            totalSaving = minPrice;
            subTotal-=minPrice;
            $('.fon-bf-sub-total .with-currency-code').html(subTotal);
        }

        $('.bf-item-add-on').each(function() {

            const price = parseFloat($(this).attr('data-variant-price')) || 0;
            const ogPrice = parseFloat($(this).attr('data-variant-og-price')) || 0;

            subTotal += price;
            newtotalItems++;

            totalAmount+= price;
            totalSaving+= (ogPrice - price);
            
        });

        $('.fon-bf-sub-total .with-currency-code').html(subTotal);

        $('.save-el').remove();
        if (totalSaving > 0){
            $('#offer .fon-bf-sub-total .with-currency-code').before(`
                <span class="save-el">
                    <span class="save-text">You Save $${totalSaving}</span>
                    <span class="total-amount">$${totalAmount}</span>
                </span>
            `);

            $('.saving-amount').html(totalSaving);
        }

    }
    
    

    
    

    // Black Friday end in Australia (AEDT/AEST)
    // 29 Nov 2025 00:00 AEDT -> 28 Nov 2025 13:00 UTC
    // var blackFridayEnd = new Date(Date.UTC(2025, 10, 28, 13, 0, 0));
    // var now = new Date();
    // var blackFridayEnd = new Date(now.getTime() + 8 * 60 * 1000); // 8 minutes in milliseconds

    // console.log(future.toString());


    // function updateCountdown() {
    //     var now = new Date(); // local time
    //     var nowUtc = new Date(now.getTime() + now.getTimezoneOffset() * 60000); // convert to UTC
    //     var diff = blackFridayEnd - nowUtc;

    //     if (diff <= 0) {
    //         $('#timer').text('EXPIRED');
    //         clearInterval(interval);
    //         return;
    //     }

    //    var days = Math.floor(diff / 1000 / 60 / 60 / 24);
    //     var hours = Math.floor((diff / 1000 / 60 / 60) % 24);
    //     var minutes = Math.floor((diff / 1000 / 60) % 60);
    //     var seconds = Math.floor((diff / 1000) % 60);

    //     $('#timer').text(
    //     days + "d " +
    //     ('0' + hours).slice(-2) + ":" +
    //     ('0' + minutes).slice(-2) + ":" +
    //     ('0' + seconds).slice(-2)
    //     );

    //     $('#countdown-2 #timer-2').html($('#timer').html());
    //     $('.countdown-html').html($('#timer').html());
    // }

    // Set countdown for 8 minutes from now
var now = new Date();
var blackFridayEnd = new Date(now.getTime() + 9 * 60 * 1000); // 8 minutes in milliseconds

console.log(blackFridayEnd.toString());

// Update countdown every 50 milliseconds for smooth milliseconds display
var interval = setInterval(updateCountdown, 50);

function updateCountdown() {
    var now = new Date();
    var diff = blackFridayEnd - now; // difference in milliseconds

    if (diff <= 0) {
        $('#timer').text('EXPIRED');
        clearInterval(interval);
        return;
    }

    var minutes = Math.floor((diff / 1000 / 60) % 60);
    var seconds = Math.floor((diff / 1000) % 60);
    var milliseconds = Math.floor((diff % 1000) / 10); // two digits

    $('#timer').text(
        ('' + minutes).slice(-2) + " minutes " +
        ('0' + seconds).slice(-2) + " seconds"
    );

    $('#countdown-2 #timer-2').html($('#timer').html());
    $('.countdown-html').html($('#timer').html());
}


    // initial call
    updateCountdown();
    var interval = setInterval(updateCountdown, 1000);


    let $items = $(".limited-time");
    let index = 0;

    // set first active
    $items.eq(index).addClass("active");

    setInterval(function(){
        // remove all
        $items.removeClass("active");

        // set active
        index = (index + 1) % $items.length;
        $items.eq(index).addClass("active");
    }, 1275);


    $(document).on('click','.fon-bf-quick-add-ons button',function(){

        var variantID = $(this).attr('data-variant-id');
        var variantIDFrother = $(this).attr('data-variant-id-frother');
        var ogButton = $(this).attr('data-og-button');

       if ($(this).hasClass('active')){
            $(this).removeClass('active').html(ogButton);
            $('.bf-item-add-on-' + variantID).remove();
            $('.bf-item-add-on-' + variantIDFrother).remove();
       }else{
            $(this).addClass('active').html('Remove');

            var parent = $(this).parents('.collection-product-item'); 
            var image = parent.find('img').attr('src');
            var title = $(this).attr('data-variant-title');


            var price = $(this).attr('data-variant-price');
            var priceOG = $(this).attr('data-variant-og-price');

            var priceFrother = $(this).attr('data-variant-price-frother');
            var priceOGFrother = $(this).attr('data-variant-og-price-frother');
            

            var html = `
            <div class="bf-item bf-item-add-on bf-item-add-on-${variantID}" data-variant-id="${variantID}"
            
                data-variant-price="${price}"
                data-variant-og-price="${priceOG}"

                >
                <div class="image">
                    <img src="${image}">
                </div>
                <div class="title">
                    <span class="label-step">${title}</span>
                </div>
                <div class="price">
                    <span class="with-currency-code">${price}</span>
                </div>
            </div>
            <div class="bf-item bf-item-add-on bf-item-add-on-${variantIDFrother}" data-variant-id="${variantIDFrother}"
            
                data-variant-price="${priceFrother}"
                data-variant-og-price="${priceOGFrother}"

                >
                <div class="image">
                    <img src="${image}">
                </div>
                <div class="title">
                    <span class="label-step">${title}</span>
                </div>
                <div class="price">
                    <span class="with-currency-code">${price}</span>
                </div>
            </div>
            `;

            $('#offer .fon-bf-selected-products').append(html);

       }
       generateItems();
    });

    

    $('.btn-quiz-form-cart-action').on('click', function() {

        $('.pyro').show();

        setTimeout(function(){
            $('.pyro').fadeOut();
        },1500)


        var $btn = $(this);
        var originalText = $btn.html(); // store original text

        // Step 0: Update button UI
        $btn.text('Preparing your cart...').prop('disabled', true);

        // Step 1: Build cartItems array
        var cartItems = [];

        // From active buttons
        $('.bf-item-add-on').each(function() {
            var variantID = $(this).attr('data-variant-id');

            if (variantID) {
                cartItems.push({ id: variantID, quantity: 1 });
            }
        });

        console.log('selectedItems',selectedItems);

        // Ensure selectedItems exists and is an array
        if (Array.isArray(selectedItems) && selectedItems.length > 0) {
            // Map each ID to the Shopify cart format and push into cartItems

            var counter = 1;
            var selectedCartItems = selectedItems.map(function(variantID) {

                
                if (counter == $('.bf-item.lowest-price').attr('data-item') ){
                    var variantEl = $('.quiz-variant-item[data-variant-id="'+variantID+'"]');
                    var variantSku = variantEl.attr('data-variant-sku');
                    variantID = $('.change-variant-id[data-variant-sku="'+variantSku+'"]').attr('data-variant-id');
                }   
                counter++;

                return { id: variantID, quantity: 1 };
            });

            // Merge into cartItems
            cartItems = cartItems.concat(selectedCartItems);
        }

        if (!cartItems.length) {
            alert('No items selected!');
            $btn.text(originalText).prop('disabled', false);
            return;
        }

        // Step 2: Clear the cart
        $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success: function() {
                // Step 3: Add items to cart
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: JSON.stringify({ items: cartItems }),
                    contentType: 'application/json',
                    dataType: 'json',
                    success: function() {
                        $btn.html(originalText).prop('disabled', false);
                        
                        window.location.href = '/checkout?discount=HS-BUY2GET1';
                    },
                    error: function(err) {
                        console.error('Error adding items:', err);
                        // Restore button
                        $btn.html(originalText).prop('disabled', false);
                    }
                });
            },
            error: function(err) {
                
                console.error('Error clearing cart:', err);
                // Restore button
                $btn.html(originalText).prop('disabled', false);
            }
        });
    });

    var swiperAdOns = new Swiper('.swiper-bf-add-ons', {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: false,
        autoplay: false,
        pagination: false,
        navigation: false,
        breakpoints: {
        768: { // tablet and up
            slidesPerView: 1,
            spaceBetween: 15,
        }
        }
    });

    $('.feature-option').click(function() {
        var index = $(this).index();

        // Toggle active class on options
        $('.feature-option').removeClass('active');
        $(this).addClass('active');

        // Toggle corresponding content
        $('.feature-content').removeClass('active').eq(index).addClass('active');

        // Toggle corresponding image
        $('.feature-image').removeClass('active').eq(index).addClass('active');

        $('section.section-quiz.section-quiz-features h2').removeClass('active').eq(index).addClass('active');



    });



    $('a[href="#get"]').on('click', function(e){
        e.preventDefault(); // prevent default jump
        var target = this.hash; // "#get"
        $('html, body').animate({
            scrollTop: $(target).offset().top
        }, 800, function(){
            window.location.hash = target; // optional: update URL
        });
    });


    const swiperReviews = new Swiper('.swiper-reviews-text', {
        slidesPerView: 5,
        spaceBetween: 15,
        loop: true,          // enable infinite loop
        navigation: false,
        pagination: false,
        autoHeight: true,
    });
});
